// Билдеры внутренних ссылок Трипстера. Собраны в одном месте, чтобы не
// дублировать шаблоны путей по компонентам.

export const experienceUrl = (id: number | string): string => `/experience/${String(id)}/`;

export const experienceCityUrl = (citySlug: string): string => `/experience/${citySlug}/`;

// У России туры разбиты по регионам, поэтому в URL добавляется slug региона;
// для остальных стран — общая страница туров по стране.
export const toursUrl = (countrySlug: string, slug?: string | number): string =>
  countrySlug === 'russia' ? `/tours/${countrySlug}/${String(slug)}/` : `/tours/${countrySlug}/`;

export const articleUrl = (slug: string): string => `/journal/articles/${slug}/`;

export const articleCountryUrl = (slug: string): string => `/journal/country/articles/${slug}/`;

export const cityTagUrl = (citySlug: string, citytagId: number | string, slug: string): string =>
  `/experience/${citySlug}/${String(citytagId)}-${slug}/`;

// Абсолютная ссылка сезонного блока (кнопка ведёт на текущий origin).
export const absoluteSeasonUrl = (url: string): string => `${window.location.origin}${url}/`;
